import { DisplayItem, DisplayItemType } from './display-item';

/**
 * Display Item, welches die Informationsevents kapselt
 * Begründung: erfüllt keine AFO, ist reine Design Komponente
 */
export class DisplayInfo extends DisplayItem {
  override get type(): DisplayItemType {
    return DisplayItemType.INFO;
  }

  constructor(
    id: string | undefined,
    private readonly _infotext: string,
    private readonly _personalizedInfotext: string,
    private readonly _timestamp: number,
    private readonly _sender: string
  ) {
    super(id);
  }

  get infotext(): string {
    return this._infotext;
  }

  get personalizedInfotext(): string {
    return this._personalizedInfotext;
  }

  get timestamp(): number {
    return this._timestamp;
  }

  get sender(): string {
    return this._sender;
  }
}
